import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Button, Checkbox, FormGroup, Switch } from "@blueprintjs/core";
import { IntegrationStore } from "../../stores/xml-integracao/IntegrationStore";
import { toast } from "react-toastify";
import { MODELOS_INTEGRATION } from "../../utils";

@observer
export default class Questor extends React.Component<{}, {}> {

  obs = observable({})

  constructor(props: {}) {
    super(props);
  }

  async handleSaveToken() {

    if (!IntegrationStore.obs.selectedEmpresa.cnpj) {
      toast.warning('Você precisa selecionar uma empresa.', {});
      return
    }

    if (!Object.values(IntegrationStore.obs.modelos_integration_questor).some(Boolean)) {
      toast.warning('Você precisa selecionar pelo menos um Modelos de Importação.', {});
      return
    }

    let data = {
      cnpj: IntegrationStore.obs.selectedEmpresa.cnpj,
      envio_automatico: IntegrationStore.obs.envio_automatico_questor_api,
      tipo: "questor",
      modelos_integration_questor: IntegrationStore.obs.modelos_integration_questor
    }

    await IntegrationStore.handleSaveToken(data)

  }

  handleChangeEnvio = async (e) => {

    const newValue = e.target.checked;

    IntegrationStore.obs.envio_automatico_questor_api = newValue

  };

  render() {

    return (
      <>

        <FormGroup label="Envio Automático">
          <Switch
            label={IntegrationStore.obs.envio_automatico_questor_api ? "Ativado" : "Desativado"}
            checked={IntegrationStore.obs.envio_automatico_questor_api}
            onChange={(e: any) => this.handleChangeEnvio(e)} />
        </FormGroup>

        {IntegrationStore.obs.envio_automatico_questor_api && (<>
          <FormGroup label="Modelos de Importação" labelInfo="*">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(100px, 1fr))", gap: 15, width: "max-content" }}>
              {MODELOS_INTEGRATION.map((item) => (
                <Checkbox
                  key={item.id}
                  disabled={["nfse_tomador", "nfse_prestador"].includes(item.id)}
                  type="checkbox"
                  label={item.name}
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    width: "max-content",
                    maxWidth: "100%",
                  }}
                  checked={!!IntegrationStore.obs.modelos_integration_questor[item.id]}
                  onChange={(e: any) => {
                    IntegrationStore.obs.modelos_integration_questor = {...IntegrationStore.obs.modelos_integration_questor, [item.id]: e.target.checked};
                  }}
                />
              ))}
            </div>
          </FormGroup>
        </>)}

        <Button intent="primary" onClick={() => this.handleSaveToken()}>Salvar configuração</Button>

      </>
    )
  }


}